<template>
  <b-container>
    <manifest-list />
  </b-container>
</template>
<script>
import ManifestList from '@/components/ManifestList'

export default {
  name: 'ManifestsPage',
  title() {
    return this.$gettext('Ongoing Manifests')
  },
  components: {
    ManifestList
  }
}
</script>
